export class AddressBo
{
    address_components:any
    formatted_address:any;
    isChanged:boolean=false;
    clientLocationLongitude:any;
    clientLocationLatitude:any;
}